import { Controller } from 'stimulus';

export default class extends Controller {
  static values = { backPath: String }

  initialize() {
    console.log("Form Controller - Initialize")
  }

  submit(event) {
    event.preventDefault()
    $(this.element).submit()
  }

  disconnect() {
    console.log("Form Controller - Disconnect")
  }
}
